import countries from "world-countries";

export type CountryOption = {
  english: string;
  translations: Record<string, string>;
};

const LANG_TO_ISO3: Record<string, string> = {
  de: "deu",
  en: "eng",
  nb: "nor",
};

export const COUNTRY_OPTIONS: CountryOption[] = countries.map((c: any) => ({
  english: c.name.common,
  translations: Object.fromEntries(
    Object.entries(c.translations || {}).map(([key, val]: any) => [key, val.common])
  ),
}));

export function getLocalizedCountryName(option: CountryOption, lang: string): string {
  const iso3 = LANG_TO_ISO3[lang.split("-")[0]] ?? "eng";
  return option.translations[iso3] ?? option.english;
}

export function getSortedCountryOptions(lang: string): CountryOption[] {
  return [...COUNTRY_OPTIONS].sort((a, b) =>
    getLocalizedCountryName(a, lang).localeCompare(getLocalizedCountryName(b, lang), lang)
  );
}
